import axios from 'axios';
import store from '../store';
import { getTokenName, encryptNormal, encryptJson } from './config';
import { Message } from 'element-ui';

import { loading } from '../commons/loading';

import { getToken, getBaseURL, getEnvIdentity } from '@/commons/utils';

let httpCount = 0;

/**
 * 获取签名
 * @param {*} config
 */
function getSign(config) {
    let time = new Date().getTime();
    if (!config.params) {
        config.params = {};
    }
    config.params.time = time;
    if (config.method.toLowerCase() === 'get') {
        config.params = Object.assign(config.params, config.data);
        config.params.sign = encryptNormal(config.params);
        config.headers['Content-Type'] = '';
        return config;
    }

    if (
        config.headers['Content-Type'] &&
        config.headers['Content-Type'].indexOf('multipart') !== -1
    ) {
        config.params = Object.assign(config.params, config.data);
        config.params.sign = encryptNormal(config.params);
        return config;
    }
    // 说明是application/json请求方式
    if (config.headers.common.Accept.indexOf('json') !== -1) {
        if (typeof config.data === 'undefined' || config.data == null) {
            config.params.sign = encryptJson(time);
        } else {
            config.params.sign = encryptJson(
                JSON.stringify(config.data) + time
            );
        }
    } else {
        config.params = Object.assign(config.params, config.data);
        config.params.sign = encryptNormal(config.params);
    }
    return config;
}

/**
 * 请求拦截器
 */
axios.interceptors.request.use(
    function(config) {
        if (!config.noToken) {
            let token = getToken();
            if (token) {
                let tokenName = getTokenName(config.url);
                config.headers[tokenName] = getToken();
            }
        }
        if (config.url.indexOf('stable') > -1) {
            const envIdentity = getEnvIdentity();
            envIdentity &&
                (config.headers['X-Hades-Env-Identity'] = envIdentity);
        }
        config.timeout = 30000;
        if (!config.noLoading) {
            openLoading();
        }
        return getSign(config);
    },
    function(error) {
        return Promise.reject(error);
    }
);

/**
 * 接口处理
 * @param resp
 * @param resolve
 */
function successHandler(resp, resolve, reject) {
    if (resp.request.responseType === 'arraybuffer') {
        if (
            resp.headers &&
            resp.headers['content-type'] &&
            resp.headers['content-type'].indexOf('application/json') > -1
        ) {
            let reader = new FileReader();
            reader.onload = e => {
                errorHandler(
                    {
                        data: JSON.parse(e.target.result)
                    },
                    reject
                );
            };
            reader.readAsText(new Blob([resp.data]));
        } else {
            resolve(resp);
        }
    } else {
        if (!resp.data.code || resp.data.success || resp.config.pass) {
            resolve(resp.data);
        } else {
            errorHandler(resp, reject);
        }
    }
}

/**
 * 错误接口处理
 * @param error
 */
function errorHandler(resp, reject) {
    let errText = '';
    if (!resp) {
        errText = `异常信息：系统异常`;
    } else if (resp.status === 401) {
        errText = `异常信息：${resp.status}—${resp.statusText}`;
        store.dispatch('sys/logout');
    } else if (resp.status !== 200) {
        if (resp.config.passErr) {
            reject(resp);
        }
        errText = `异常信息：${resp.status}—${resp.statusText}`;
    } else if (resp.data) {
        errText = `${resp.data.message || '系统异常'}`;
        if (resp.data.code === 401) {
            store.dispatch('sys/logout');
        } else {
            if (resp.config.passErr) {
                reject(resp.data);
            }
        }
    } else {
        errText = `异常信息：系统异常`;
    }
    Message({
        title: '提示',
        message: errText,
        type: 'error',
        duration: 3000
    });
    closeLoading();
}

/**
 * 为全局对象Vue绑定fetch函数
 * @param apiName
 * @param params
 * @returns {*}
 */
export const fetch = item => {
    return new Promise((resolve, reject) => {
        if (
            !Object.prototype.hasOwnProperty.call(item, 'method') ||
            item.method.toUpperCase() === 'GET' ||
            item.method.toUpperCase() === 'DELETE' ||
            item.method.toUpperCase() === 'PUT'
        ) {
            item.params = !Object.prototype.hasOwnProperty.call(item, 'params')
                ? item.params
                : item.data;
        }
        axios(item)
            .then(resp => {
                successHandler(resp, resolve, reject);
            })
            .catch(err => {
                errorHandler(err.response, reject);
            });
    }).finally(() => {
        closeLoading();
    });
};

/**
 * 打开加载浮层
 */
function openLoading() {
    if (httpCount === 0) {
        loading.open();
    }
    httpCount++;
}

/**
 * 关闭加载浮层
 */
function closeLoading() {
    if (httpCount > 0) {
        httpCount--;
    }
    if (httpCount === 0) {
        loading.close();
    }
}

export const base = getBaseURL('base');
export const upload = getBaseURL('upload');
export const addr = getBaseURL('addr');
